"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleEvents = handleEvents;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _index = require("../filters/index");

var _utils = require("../utils");

var _runtime = _interopRequireDefault(require("../utils/runtime"));

var _path = require("../utils/path");

var _constants = require("../constants");

var _logger = _interopRequireDefault(require("../logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function validateMetrics(event) {
  var isValid = (0, _index.isMetricsValid)(event.message.metrics, event.message.metricsPredicate);

  if (!isValid) {
    _logger.default.error('不合法的 prometheus 上报数据', event);
  }

  return isValid;
}

function filterEvent(event) {
  var valid = true;
  var keys = Object.keys(event);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = event[key];

    if (typeof value === 'undefined' || value === '') {
      valid = false;

      _logger.default.error('不合法的 prometheus 上报数据', event);

      break;
    }
  }

  return valid;
}

function formatEvent(event) {
  var _event$message = event.message,
      metrics = _event$message.metrics,
      attributes = _event$message.attributes;
  var filteredAttributes = (0, _index.filterAttributes)(_constants.PROMETHEUS_ENDPOINT_NAME, event.type, attributes);
  var transformedMetrics = (0, _utils.transformToCamelCase)(metrics);
  var transformedAttributes = (0, _utils.transformToCamelCase)(filteredAttributes);

  var pathname = transformedAttributes.pathname,
      rest = _objectWithoutProperties(transformedAttributes, ["pathname"]);

  var formatted = _objectSpread({
    type: event.type,
    url: event.url || (0, _path.getUrl)()
  }, transformedMetrics, {}, rest);

  if (event.type === 'network_api') {
    // network_api 传递业务类型
    var extra = (0, _utils.getCurrentRouteChannelExtra)(_constants.PROMETHEUS_ENDPOINT_NAME);
    formatted = _objectSpread({}, formatted, {
      businessType: extra.businessType || _constants.UNKNOWN,
      businessChildType: extra.businessChildType || _constants.UNKNOWN
    });
  }

  formatted = processSpecialCases(formatted, transformedAttributes);
  return formatted;
}

function processSpecialCases(event, attributes) {
  var pathname = attributes.pathname;

  if (pathname) {
    event.pathName = pathname;
  }

  if (event.type === 'page_perf' && event.mode === 'ssr') {
    event.isRouteChange = 'false';
  }

  return event;
}

function getEndPointUrl() {
  var env = _runtime.default.get('env');

  return "".concat(_constants.PROMETHEUS_ENDPOINT_DOMAIN[env] || '').concat(_constants.PROMETHEUS_ENDPOINT_PATH);
}

function readyTransport(events) {
  var shouldLog = _runtime.default.get('shouldLog');

  var shouldReport = _runtime.default.get('shouldReport');

  if (shouldLog) {
    _logger.default.info("\n[performance-collect]:\n  endPoint: Prometheus,\n  events: ".concat(JSON.stringify(events, null, 4), "\n"));
  }

  if (shouldReport) {
    return transport(events);
  }

  return Promise.resolve();
}

function transport(events) {
  var url = getEndPointUrl();
  return _axios.default.post(url, events);
}

function handleEvents(events) {
  if (!(0, _utils.currentRouteChannelEnabled)(_constants.PROMETHEUS_ENDPOINT_NAME)) {
    return Promise.resolve();
  }

  var formattedEvents = events.filter(validateMetrics).map(function (event) {
    var e = formatEvent(event);
    return e;
  }).filter(filterEvent);
  return readyTransport(formattedEvents);
}